export const GET_PERMISSIONS = 'GET_PERMISSIONS'
export const GET_PERMISSION = 'GET_PERMISSION'
